import { List } from "@mui/material";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import ConfigSectorsActioner from "services/configSectors/actioner";
import Placeholder from "components/Placeholder";
import ConfigSectorForm from "./ConfigSectorForm";

function ConfigSectorContainer({
  areaSelected,
  retrieveSectorsData,
  sectorLoading,
  sectors,
}) {
  useEffect(() => {
    if (areaSelected !== undefined) {
      retrieveSectorsData();
    }
  }, [areaSelected, retrieveSectorsData]);

  if (sectorLoading || sectorLoading === undefined) {
    return <Placeholder />;
  }

  return (
    <List component="div" disablePadding>
      {sectors
        ?.find((s) => s.area_id === areaSelected)
        ?.sectors.map((sector, index) => (
          <ConfigSectorForm key={index} sector={sector} />
        ))}
    </List>
  );
}

const mapStateToProps = (state) => ({
  areaSelected: state.ConfigSectors.areas.selected,
  sectorLoading: state.ConfigSectors.sectors.loading,
  sectors: state.ConfigSectors.sectors.items,
});

const mapDispatchToProps = (dispatch) => ({
  retrieveSectorsData: () =>
    dispatch(ConfigSectorsActioner.retrieveSectorsData()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfigSectorContainer);
